export default "__VITE_ASSET__BE2Vzth4__"